import { Autocomplete, capitalize, InputLabel, OutlinedInput, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Field, ErrorMessage } from 'formik';
import { useState } from 'react';
import { useAsync } from 'react-async';

const SelectInput = ({ fieldDisplay = 'name', filterField = '', helperText, preventFormikSetValue, filterValue = 'code', error, customChange, readOnly, selectFunction, ...props }) => {
    const [open, setOpen] = useState(false);
    const { data, isLoading } = useAsync({ promiseFn: selectFunction });

    let options = data?.resultObject || data || props?.options || [];
    if (filterField) options = options.filter((op) => op[filterField] === filterValue);

    return (
        <Field id={props.id} name={props.id} label={props.label}>
            {({ field, form }) => (
                <div>
                    <InputLabel className="label">
                        {props.label} {props?.required && '*'}
                    </InputLabel>
                    <Autocomplete
                        id={props.id}
                        name={props.id}
                        label={null}
                        options={options.sort((a, b) => (a[fieldDisplay] > b[fieldDisplay] ? 1 : -1))}
                        getOptionLabel={(option) => capitalize(option[fieldDisplay] || '')}
                        value={options.filter((lval) => lval[props.field] === field.value)[0] || null}
                        onChange={(e, value) => {
                            if (value) {
                                form.setFieldValue(field.name, value[props.field]);
                                form.setTouched({
                                    ...form.touched,
                                    [field.name]: false,
                                });
                            } else if (props?.required && !props?.readOnly) {
                                form.setTouched({
                                    ...form.touched,
                                    [field.name]: true,
                                });
                            } else {
                                form.setFieldValue(field.name, '');
                            }
                            if (customChange) customChange(field.name, value?.[props.field] || '', value);
                        }}
                        onBlur={() => {
                            form.setTouched({
                                ...form.touched,
                                [field.name]: true,
                            });
                        }}
                        inputProps={{
                            style: { padding: '11px 14px', fontSize: '14px' },
                        }}
                        open={open}
                        onOpen={() => !readOnly && setOpen(true)}
                        onClose={() => setOpen(false)}
                        disableClearable={readOnly}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name={props.id}
                                placeholder={props?.placeholder || `Select ${props.label}`}
                                label={null}
                                required={props.required}
                                variant="outlined"
                                fullWidth
                                error={Boolean(form.errors[props.id] && form.touched[field.name])}
                                inputProps={{
                                    ...params.inputProps,
                                    ...props,
                                }}
                                helperText={form.errors[props.id] && form.touched[field.name] ? form.errors[props.id] : helperText || ''}
                            />
                        )}
                        required={props.required}
                        variant="outlined"
                    />
                    {/* <ErrorMessage className="error input-feedback" component="div" name={props.id} /> */}
                </div>
            )}
        </Field>
    );
};

export default SelectInput;
